module.exports = __webpack_public_path__ + "cancellara-dist/img/homepage-banner-giftcard.67321b1b.jpg";